module.exports = __webpack_public_path__ + "static/media/sayabout-user1.5962553f.jpg";